import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'usageStats',
  initialState: {
    data: {
      resume: {
        active_students: 0,
        active_teachers: 0,
        registered_students: 0,
        registered_teachers: 0,
        total_classes: 0,
        total_students_usage_time: 0,
        total_teachers_usage_time: 0,
        total_centers: 0,
      },
      stats: [],
    },
  },
  reducers: {
    setStats: (state, { payload: obj }) => {
      state.data = obj;
    },
  },
});

export const { setStats } = slice.actions;

export default slice.reducer;

export const selectStats = (state) => state.usageStats.data;
